import { useEffect } from "react";

export default function Adsense() {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-5162535306990850"
      data-ad-slot="2355314522"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}